import React from "react";
import BrsrCardWithForm from "./BrsrCardWithForm";
import { sectionDetailsSample } from "../../../../utils/schema/sectionDetailsSample";
import { questionsWithSections } from "../../../../utils/schema/questionsWithSections";
const EnvironmentBrsrReport = () => {
  const filteredQuestions = sectionDetailsSample.subSections
    .map((section) => {
      const questionsForSection = questionsWithSections.data.find(
        (questionSection) => questionSection.sectionId === section.SubSectionId
      );

      if (questionsForSection) {
        return {
          id: section.SubSectionId,
          title: section.SubSectionTitle,
          questions: questionsForSection.questions,
        };
      }
      return null;
    })
    .filter(Boolean);

  return (
    <div className="px-28">
      <h1 className="text-xl font-bold mb-4">
        {sectionDetailsSample.sectionTitle}
      </h1>
      <BrsrCardWithForm cards={filteredQuestions} />
    </div>
  );
};

export default EnvironmentBrsrReport;
